import jsPDF, { jsPDF as JsPDF } from 'jspdf'
// eslint-disable-next-line import/no-extraneous-dependencies
import pdfMake from 'pdfmake'
// eslint-disable-next-line import/extensions
import pdfFonts from 'pdfmake/build/vfs_fonts.js'

class PdfService {
  private defaultOptionsJsPdf = {
    size: 1000,
    margin: 0,
    fileName: 'pdf.pdf',
  }

  private defaultOptionsPdfMake = {
    fileName: 'pdf.pdf',
  }

  async generateFromHtml(html: string, options = this.defaultOptionsJsPdf) {
    const { size, margin, fileName } = options

    const doc = new JsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    })

    const scale = (doc.internal.pageSize.width - (margin * 2)) / size
    await doc.html(html, {
      x: 0,
      y: 0,
      autoPaging: 'text',
      margin: [margin, margin, margin, margin],
      html2canvas: { scale },
    })

    doc.save(fileName)
  }

  async generateFromReferenceElement(element: string | HTMLElement, options: {
    orientation: 'p' | 'portrait' | 'l' | 'landscape' | undefined;
    fileName: string,
  } = { orientation: 'portrait', fileName: 'arquivo.pdf' }) {
    const { orientation, fileName } = options

    const document = new JsPDF({
      orientation,
      unit: 'px',
      format: 'a4',
      compress: true,
    })

    return new Promise<void>((resolve, reject) => {
      try {
        document.html('', {
          callback: (pdfInstance) => {
            pdfInstance.html(element, {
              x: 2,
              y: 2,
              html2canvas: {
                scale: 0.5,
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
              },
              callback: (file) => {
                file.save(`${fileName}.pdf`)
                resolve()
              },
            })
          },
          html2canvas: {
            scale: 0,
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
          },
          x: 0,
          y: 0,
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  async generateFromHtmlWithMultiplePages(element: string | HTMLElement, options: {
    orientation: 'p' | 'portrait' | 'l' | 'landscape' | undefined;
    fileName: string,
    margin: number,
    uploadFile?: boolean,
  } = { orientation: 'portrait', fileName: 'arquivo.pdf', margin: 10, uploadFile: false }) {
    const { orientation, fileName, margin, uploadFile } = options

    const A4_WIDTH = 793.7007874  // Largura de uma página A4 em pixels
    const A4_HEIGHT = 1122.519685 // Altura de uma página A4 em pixels
    const MM2PX = 3.7795275591    // Conversão de milimetros para pixels
    const WINDOW_HEIGHT = orientation === 'portrait' ? A4_HEIGHT - (margin * 2 * MM2PX) : A4_WIDTH - (margin * 2 * MM2PX)
    const WINDOW_WIDTH = orientation === 'portrait' ? A4_WIDTH - (margin * 2 * MM2PX) : A4_HEIGHT - (margin * 2 * MM2PX)

    const document = new JsPDF({
      orientation,
      unit: 'px',
      format: 'a4',
      compress: true,
    })

    return new Promise<void | Blob>((resolve, reject) => {
      try {
        document.html('', {
          callback: (pdfInstance) => {
            pdfInstance.html(element, {
              x: 5,
              y: 5,
              margin: [margin, margin, margin, margin],
              html2canvas: {
                windowHeight: WINDOW_HEIGHT,
                windowWidth: WINDOW_WIDTH,
                scale: 0.55,
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
              },
              callback: (file) => {
                if (uploadFile) {
                  resolve(file.output('blob'))
                  return
                }
                file.save(`${fileName}.pdf`)
                resolve()
              },
            })
          },
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  async generateFromDefinition(definition: any, options = this.defaultOptionsPdfMake) {
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs
    const pdf = (pdfMake as any).createPdf(definition)
    pdf.download(options.fileName)
  }
}

// eslint-disable-next-line import/prefer-default-export
export const pdfService = new PdfService()
